export default "__VITE_ASSET__KfTw2iS6__"